<template>
    <ModalComponent
        :name="name"
        title="Descargar informe arqueo de caja"
        @close="close()"
    >
        <div class="card-body">
            <div class="row">
                <div class="col-12 mb-3" v-if="sesiones">
                    <label for="sesion">Sesión</label>
                    <multiselect
                        v-model="sesion"
                        placeholder="Buscar sesión"
                        track-by="id"
                        :custom-label="customLabel"
                        :options="sesiones"
                    />
                </div>
                <div class="col-12 mb-3" v-if="taquilleros">
                    <label>Taquillero</label>
                    <multiselect
                        v-model="taquillero"
                        placeholder="Buscar taquillero"
                        label="email"
                        track-by="id"
                        :disabled="user.role === 11"
                        :options="taquilleros"
                    />
                </div>
                <div class="col-12">
                    <div class="form-group">
                        <label for="fecha_envio">Fecha de inicio</label>
                        <datetime
                            v-model="fecha_inicio"
                            input-class="form-control"
                            type="date"
                            input-id="fecha_inicio"
                        ></datetime>
                    </div>
                </div>
                <div class="col-12">
                    <div class="form-group">
                        <label for="fecha_envio">Fecha de fin</label>
                        <datetime
                            v-model="fecha_fin"
                            input-class="form-control"
                            type="date"
                            input-id="fecha_fin"
                        ></datetime>
                    </div>
                </div>
                <div class="col-12 text-right">
                    <Button @click="getInformeArqueoCaja()">DESCARGAR</Button>
                </div>
            </div>
        </div>
    </ModalComponent>
</template>

<script>
import ModalComponent from "@/components/backend/components/ModalComponent";

export default {
    props: ['name', 'evento_id', 'sesion_id', 'taquillero_id', 'sesiones', 'taquilleros'],
    data() {
        return {
            fecha_inicio: null,
            fecha_fin: null,
            sesion: null,
            taquillero: null
        }
    },
    watch: {
        sesion_id(newValue) {
            this.sesion = this.sesiones?.find(sesion => sesion.id == newValue);
        },
        taquillero_id(newValue) {
            this.taquillero = this.taquilleros?.find(taquillero => taquillero.id == newValue);
        }
    },
    computed: {
        user(){
            return this.$store.getters.getUser;
        },
        teatro() {
            return this.$store.getters.getTeatro;
        }
    },
    methods: {
        getInformeArqueoCaja() {
            const sesion_id = this.sesion_id ?? this.sesion?.id;
            const taquillero_id = this.taquillero_id ?? this.taquillero?.id;

            var enlace = this.config.API_BASE + '/eventos/' + this.evento_id + '/informe/arqueo-caja?api_key=' + localStorage.getItem('token') + '&teatro_id=' + this.teatro.id + '&tid=' + this.teatro.hash;

            if (this.fecha_inicio) {
                enlace +=  '&fecha_inicio=' + this.fecha_inicio;
            }
            if (this.fecha_fin) {
                enlace +=  '&fecha_fin=' + this.fecha_fin;
            }
            if (sesion_id) {
                enlace +=  '&sesion_id=' + sesion_id;
            }
            if (taquillero_id) {
                enlace +=  '&taquillero_id=' + taquillero_id;
            }

            window.open(enlace);
            this.close();
        },
        customLabel(sesion) {
            var texto = sesion.fecha;

            if (sesion.text) {
                texto += (' - ' + sesion.text)
            }

            return texto; 
        },
        close() {
            this.$emit('close', this.name);
        }
    },
    components: {
        ModalComponent
    }
}
</script>
